import { Box, FormControl, RadioGroup, FormControlLabel, Radio, Divider } from '@mui/material';
import { ArrowBackIos, ArrowForwardIos } from '@mui/icons-material';
import { useEffect, useState, useContext } from 'react';
import SettingsStoreList from './SettingsStoreList';
import StoreContext from '../context/StoreContext'
import UserContext from '../context/UserContext';
import Proptypes from 'prop-types'
import { formatSettingsParam } from '../utils/SettingsFormatter';
import FeedbackContext from '../context/FeedbackContext';

const SettingsItem = ({onClose, settingSelected, settingLabel, storeList, openSuccessModal}) => {

  const { username } = useContext(UserContext);
  const { setIsLoading } = useContext(FeedbackContext);

  const {
    updateSetting
  } = useContext(StoreContext);

  const [value, setValue] = useState('');
  const [showStoreList, setShowStoreList] = useState(false);

  const handleChange = async(event) => {
    setValue(event.target.value);

    if(event.target.value !== 'list') {
      const param = formatSettingsParam(settingSelected)

      setIsLoading(true)
      await updateSetting(settingSelected, param, username, event.target.value, storeList)
      setIsLoading(false) 
      openSuccessModal()
      onClose()
    }

  }

  const closeList = () => {
    setShowStoreList(false)
  }

  useEffect(() => {
    const numberOfStores = storeList.filter(store => store[settingSelected] === '1').length;
    if(numberOfStores === storeList.length) {
      setValue('all')
    } else if(numberOfStores === 0) {
      setValue('none')
    } else {
      setValue('list')
    }
  },[settingSelected, storeList]) 

  return(
    <Box sx={{marginTop: '30px'}}>
      {
        showStoreList ?
          <SettingsStoreList 
            onClose={closeList} 
            settingLabel={settingLabel} 
            settingSelected={settingSelected} 
            fullStoreList={storeList}
            setIsLoading={setIsLoading}
            openSuccessModal={openSuccessModal}
            closeSettings={onClose}
          />
        : 
          <>
            <div className='mb-16 cursor-pointer' onClick={onClose}>
              <ArrowBackIos fontSize='small'/>
              <span>Settings</span>
            </div>
            <div className='title-container'>
              {settingLabel} settings
            </div>
            <Box className='settings-box' sx={{ border: '1px solid', borderColor: 'grey.300', borderRadius: 1 }}>
              <FormControl fullWidth>
                <RadioGroup
                  defaultValue='list'
                  name='radio-buttons-group'
                  value={value}
                  onChange={handleChange}
                  sx={{padding: '10px'}}
                >
                  <FormControlLabel value='all' control={<Radio size='small' color='success'/>} label='Active in all stores' sx={{padding: '10px'}}/>
                  <Divider sx={{width: '96%', margin: 'auto'}}/>
                  <FormControlLabel value='none' control={<Radio size='small' color='success'/>} label='Inactive in all stores' sx={{padding: '10px'}}/>
                  <Divider sx={{width: '96%', margin: 'auto'}}/>
                  <FormControlLabel 
                    value='list' 
                    control={<Radio size='small' color='success'/>} 
                    label={
                      <div className='w-full flex items-center'>
                        Active at select stores
                        <div 
                          className={`absolute right-8 ${value !== 'list' ? 'settings-disabled-text' : 'settings-enabled-text'}`} 
                          onClick={() => value === 'list' ? setShowStoreList(true) : null }
                        >
                          <span>Manage stores</span>
                          <ArrowForwardIos/>
                        </div>
                      </div>
                    }
                    sx={{padding: '10px'}}
                  />
                </RadioGroup>
              </FormControl>
            </Box>
          </>
      }
    </Box>
  )
}

SettingsItem.propTypes = {
  onClose: Proptypes.func,
  settingSelected: Proptypes.string,
  settingLabel: Proptypes.string,
  storeList: Proptypes.array,
  openSuccessModal: Proptypes.func
}

export default SettingsItem;
